module.exports = new __parcel__URL__("love.a30d219d.webp").toString();